"use client";

import { Award, BookOpen, Sparkles } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partners() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: badgesRef,
    isVisible: badgesVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const partners = [{
    name: "TechFlow Systems",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_techflow.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_techflow.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_techflow.png-wvc-sizes"
  }, {
    name: "DataStream AI",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_datastream.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_datastream.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_datastream.png-wvc-sizes"
  }, {
    name: "CloudSync Logic",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_cloudsync.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_cloudsync.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_cloudsync.png-wvc-sizes"
  }, {
    name: "NeuralNode",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_neuralnode.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_neuralnode.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_neuralnode.png-wvc-sizes"
  }, {
    name: "AutomatePro",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_automatepro.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_automatepro.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_automatepro.png-wvc-sizes"
  }, {
    name: "ScaleOps",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_scaleops.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_scaleops.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_scaleops.png-wvc-sizes"
  }, {
    name: "InsightAI",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_insightai.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_insightai.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_insightai.png-wvc-sizes"
  }, {
    name: "WorkflowGen",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_workflowgen.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_workflowgen.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_workflowgen.png-wvc-sizes"
  }, {
    name: "BotArchitect",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_botarch.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_botarch.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_botarch.png-wvc-sizes"
  }, {
    name: "SyncMatrix",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_syncmatrix.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_syncmatrix.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_syncmatrix.png-wvc-sizes"
  }, {
    name: "LogicCore",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_logiccore.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_logiccore.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_logiccore.png-wvc-sizes"
  }, {
    name: "FutureFlow",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_futureflow.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_futureflow.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714695/img/partner_futureflow.png-wvc-sizes"
  }];
  const accolades = [{
    label: "Featured in TechCrunch",
    icon: Sparkles
  }, {
    label: "AI Innovation Award",
    icon: BookOpen
  }, {
    label: "Forbes Automation",
    icon: Award
  }];
  return <section data-section-id="547" id="trusted-partners" className="bg-background py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        {}
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">
            Strategic Alliances
          </p>
          <h2 className="font-default font-sans mt-6 text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] text-foreground">
            Our Automation <span className="italic font-normal">Ecosystem</span>
          </h2>
          <p className="mt-6 text-base md:text-lg font-default text-muted-foreground leading-relaxed">
            We integrate with the world's leading platforms to deliver seamless, high-performance AI solutions for your business.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`mt-20 md:mt-24 transition-all duration-1000 ease-out delay-150 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-8 gap-y-14 md:gap-y-16">
            {partners.map((partner, i) => <div key={i} data-index={i} className="flex items-center justify-center px-4 py-3">
                <img src={partner.image} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.name} loading="lazy" decoding="async" className="h-10 w-auto max-w-[160px] object-contain grayscale opacity-60 transition-all duration-[400ms] ease-out hover:grayscale-0 hover:opacity-100" />
              </div>)}
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-28">
          <Separator className="bg-border/60" />
        </div>

        {}
        <div ref={badgesRef} className={`mt-12 transition-all duration-1000 ease-out delay-200 ${badgesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="text-center font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-muted-foreground mb-8">
            Industry Recognition
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-y-6 gap-x-10 md:gap-x-14">
            {accolades.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} data-index={i} className="flex items-center gap-3 text-foreground/70">
                  <Icon className="h-4 w-4 text-foreground/70" strokeWidth={1.25} />
                  <span className="font-mono text-xs uppercase tracking-[0.25em]">
                    {item.label}
                  </span>
                  {i < accolades.length - 1 && <span className="hidden sm:inline-block ml-10 md:ml-14 h-3 w-px bg-border" aria-hidden="true" />}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}